import React from 'react';
import Main from './Main';

const App = () => (
  <div>
    <Main />
  </div>
)

export default App;